export function getNotifications(){
	return notifications;
}

const notifications = [
	{ title:"Latest tasks in your projects", message:"Top margin in a popup window is smaller than the..." },
	{ title:"Autocat report", message:"Navigations problem in the left menu" },
	{ title:"Assignment", message:"Gita Noda assigned you a new ticket" }
];
